export const Sidebar = function(sidebarCalss) {
  const sidebarContainer = document.querySelector(`.${sidebarCalss}`)
  const menuContainer = document.querySelector('.js-menu')
  const toggleButton = document.querySelector('.js-toggle-sidebar')

  toggleButton.addEventListener('click', function(event) {
    sidebarContainer.classList.toggle('close')
    menuContainer.classList.toggle('close')
  })
}